import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Insights } from "../components/Insights";
import { getDashboard } from "../config/ApiConfig";

const TeamListing = () => {
    const { customerKey } = useParams();
    const [clientInfo, setClientInfo] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const data = await getDashboard(customerKey);
                setClientInfo(data.data);
            } catch (error) {
                console.error('Error fetching data:', error);
                setClientInfo([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [customerKey]);

    return (
        <div>
            {isLoading ? (
                <div className="flex items-center justify-center h-screen">
                    <div className="flex flex-col items-center justify-center py-16">
                        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid" />
                        <p className="mt-4 text-gray-600">Loading data...</p>
                    </div>
                </div>
            ) : (
                <Insights caller="team"
                    clientInfo={clientInfo}
                />)}
        </div>
    );
};

export default TeamListing;
